<template>
  <div>
    <div class="ml-1 is-size-6">Bids</div>
    <span v-for="(bid, index) in bids" v-bind:key="rand() + bid.bid + bid.position">
      <span class="tags has-addons ml-1 my-0" style="display: inline-block;">
        <span class="tag is-dark" style="width: 14px;">{{ bid.position | positionToChar }}</span>
        <span
          class="tag has-background-white-ter"
          v-bind:class="{'has-text-danger': bid.bid.indexOf('H') > -1 || bid.bid.indexOf('D') > -1,
          'has-text-link': bid.bid.indexOf('PASS') > -1}"
        >{{ bid.bid | bidToString }}</span>
      </span>
      <span v-if="(index + 1) % 4 == 0">
        <br />
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: "BidComponent",
  props: {
    bids: Array,
  },
  methods: {
    rand() {
      return Math.random().toString(36).substring(7);
    },
  },
};
</script>

<style></style>
